import { render, staticRenderFns } from "./language-selector.vue?vue&type=template&id=cdb31b94&scoped=true"
import script from "./language-selector.vue?vue&type=script&lang=ts"
export * from "./language-selector.vue?vue&type=script&lang=ts"
import style0 from "./language-selector.vue?vue&type=style&index=0&id=cdb31b94&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb31b94",
  null
  
)

export default component.exports